"use client";

import { useVersionCheck } from "@/hooks/useVersionCheck";
import { UpdatePrompt } from "./update-prompt/UpdatePrompt";

const UpdatePromptWrapper = () => {
  const { showUpdatePrompt, handleUpdate, postponeUpdate } = useVersionCheck();

  if (!showUpdatePrompt) return null;

  return (
    <UpdatePrompt
      onUpdate={handleUpdate}
      onPostpone={postponeUpdate}
      open={showUpdatePrompt}
    />
  );
};

export default UpdatePromptWrapper;
